module.exports = __webpack_public_path__ + "media/assets/images/logo-x-black-c9d69acfaf852c0ddb7134208d703501.png";